<div *ngIf="showAd">
    <app-banner-adsense [bottom]="bottom" [type]="type"></app-banner-adsense>
</div>
